const state = {
    catalogoAdmin:null
}

// mutations
const mutations = {
    
    updateCatalogoAdmin(state, newC){
        state.catalogoAdmin = newC;
    },
}

export default {
    state,
    mutations
}